import { useQuery } from "@tanstack/react-query";
import { api } from "@/services/api";
import {
  DashboardData,
  SyncResult,
  TimelineResponse,
  TrackedAccountListResponse,
  UsageSummary,
} from "@/types";

const fetchDashboardData = async (): Promise<DashboardData> => {
  const [usage, trackedAccounts, timeline] = await Promise.all([
    api.get<UsageSummary>("/usage/summary"),
    api.get<TrackedAccountListResponse>("/tracked-accounts"),
    api.get<TimelineResponse>("/timeline/tweets", { page: 1, page_size: 8 }),
  ]);

  return {
    usage,
    trackedAccounts: trackedAccounts.accounts,
    recentTweets: timeline.tweets,
  };
};

export const useDashboard = () => {
  const query = useQuery({
    queryKey: ["dashboard-data"],
    queryFn: fetchDashboardData,
    refetchInterval: 30000,
    staleTime: 10000,
  });

  return {
    data: query.data,
    usage: query.data?.usage,
    trackedAccounts: query.data?.trackedAccounts ?? [],
    recentTweets: query.data?.recentTweets ?? [],
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
};

export const useSyncTrackedAccount = () => {
  return async (accountId: string): Promise<SyncResult> => {
    return api.post<SyncResult>(`/tracked-accounts/${accountId}/sync`);
  };
};
